<template>
    <div class="bax-order-list bax-order-list-icon  bax-order-multi-list-icon">
        <ul>
            <li v-for="(item, i) in formulations" :key="i">
                <a href="#" @click.prevent="gotoManageSingleFormulation(item)" class="d-md-flex flex-wrap">
                    <div class="bax-order-detail">
                        Formulation Description:
                        <div class="d-flex align-items-center">
                            <h4>{{ item.form_data.bag_details }}</h4>
                            <span class="ml-2"><i class="icon-chevron-right"></i></span>
                        </div>
                        <ul>
                            <li>{{getFormulationType(item) }}</li>
                        </ul>
                        <ul class="audit-log">
                            <li>Formulation submitted by: {{item.userSubmittedName}} at {{item.userSubmittedDate}}</li>
                        </ul>
                    </div>
                    <div class="bax-order-icon ml-auto">
                        <ul>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-pending"></i></span>Submitted for review<strong></strong>
                            </li>
                        </ul>

                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import tpnMixin from '@/mixins/tpnMixin';

    export default {
        name: 'BaxFormulationList',
        mixins: [tpnMixin],
        props: {
            formulations: {
                required: true,
            },
        },
        components: {
        },
        methods: {
            getFormulationType(item) {
                // default
                let text = '';

                if (item.form_data.use === 'general') {
                    text = 'General Stock';
                }
                if (item.form_data.patient_type === 'in_patient') {
                    text = 'In-patient';
                } else {
                    text = 'Home Patient';
                }
                if (item.patient_name.length) {
                    text += ': ' + item.patient_name;
                }
                return text;
            },
            gotoManageSingleFormulation(item) {
                this.$router.push({ name: 'TPNCustomFormulationCreate', params: { code: item.id } });
            },
        },
    };
</script>
